import React from "react";
import "./bdaybanner.css";
import bannerImg from "../../../Assets/Images/BasketBallBday/bday_banner.png";

export default function BdayBanner() {
  return (
    <div className="birthday-banner">
      {/* Content */}
      <div className="banner-content">
        <h1 className="subtitle text-clip">Shootin' School</h1>
        <p className="title text-clip">BIRTHDAY PARTIES</p>
        <p className="title highlight text-clip">ARE A SLAM DUNK!</p>
      </div>
    </div>
  );
}
